import { Box, Typography } from "@mui/material"

export default function PrivacyAgreement() {
  return (
    <>
      <Typography sx={{ fontWeight: "bold" }}>利用目的</Typography>
      <Box
        component="div"
        sx={{
          p: 3,
          width: { xs: "100%", md: "40em" },
          height: "15em",
          overflowY: "auto",
          border: "solid 1px black",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            width: "100%",
            overflowWrap: "break-word",
            maxHeight: "15em",
          }}
        >
          お預かりした個人情報は下記の通りに厳粛に管理保護してまいります。
          <br />
          同意ボタンを押していただきますと情報が送信されます。
          <br />
          <br />
          <br />
          （本サービスにおける個人情報の利用目的について）
          <br />
          「お問い合わせ区分」で選択していただいた、お問い合わせに関するご回答のため利用させていただきます。
          <br />
          <br />
          <br />
          （第三者への提供について）
          <br />
          当社では法律・法令などに基づく場合を除きましては、お預かりしました個人情報は、本人の同意を得ずに、第三者への提供はいたしません。
          <br />
          <br />
          <br />
          （個人情報提供の任意性について）
          <br />
          個人情報の提供は原則任意です。ただし、個人情報を提供いただけない場合は、該当事項につきまして当社からの情報やサービスなどのご提供ができません。
          <br />
          <br />
          <br />
          （開示対象個人情報の「利用目的の通知」「開示」「訂正、追加又は削除」「利用又は提供の拒否」に関して）
          <br />
          個人情報を提供されたお客様は、該当情報に関して「利用目的の通知」、「開示」、「訂正、追加、削除」、「利用又は提供の拒否」を要求する権利を有しております。
          <br />
          必要に応じて窓口までご連絡ください。
          <br />
          <br />
          <br /> 《個人情報相談窓口》
          <br />
          〒100-0005
          <br /> 東京都千代田区丸の内1-8-3
          <br />
          丸の内トラストタワー本館16・17階
          <br />
          株式会社アウトソーシングテクノロジー
          <br />
          個人情報マネジメントシステム事務局（経営管理本部）
          <br />
          個人情報保護管理者：阿部 永吾
          <br /> TEL:03-3286-4777 FAX:03-3286-4778
          <br />
        </Typography>
      </Box>
      <Typography sx={{ textAlign: "center", mt: "2em" }}>
        利用目的に同意いただける場合は、同意するをチェックしてください。
      </Typography>
    </>
  )
}
